<template>
  <div class="domain-stats-card">
    <div class="domain-stats-card__header">
      <span class="domain-stats-card__title">{{ title }}</span>
    </div>
    <div class="domain-stats-card__body">
      <span class="domain-stats-card__value">{{ numberWithCommas(value) }}</span>
      <div class="domain-stats-card__icon-wrap" :style="{ background: iconBgColor }">
        <slot name="icon"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DomainSummaryStatsCard',
  props: {
    title: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    iconBgColor: { type: String, default: '#f0f0f0' },
  },
}
</script>

<style scoped>
.domain-stats-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  flex: 1;
}

.domain-stats-card__header {
  padding: 14px 16px 12px;
  border-bottom: 1px solid #f6f6f6;
}

.domain-stats-card__title {
  font-size: 13px;
  font-weight: 600;
  color: #4b4b4b;
  white-space: nowrap;
}

.domain-stats-card__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  flex: 1;
  min-height: 118px;
}

.domain-stats-card__value {
  font-size: 30px;
  font-weight: 700;
  color: #4b4b4b;
}

.domain-stats-card__icon-wrap {
  width: 57px;
  height: 57px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}
</style>
